import axiosRetry from "axios-retry";
import axios from "axios";
import qs from "qs";

const BASE_API_URL = process.env.REACT_APP_GRIGORA_API_URL + "/";
// const BASE_API_URL = "http://localhost:2706/";

axiosRetry(axios, {
  retryDelay: (retryCount) => {
    return retryCount * 1000; // retry after 1, 2, 3, ... seconds
  },
});

const makeRequest = async (method, url, data, params, headers, idToken) => {
  const request = {
    method,
    url,
    data,
    params,
    headers: {
      ...headers,
      Authorization: idToken,
    },
  };
  return axios(request);
};

async function apiAction(method, action, params, type, idToken) {
  return new Promise(async (resolve, reject) => {
    try {
      if (type === "formdata") {
        var form = new FormData();
        for (var key in params) {
          if (params[key]) {
            form.append(key, params[key]);
          }
        }

        var response = await makeRequest(
          method,
          `${BASE_API_URL}${action}`,
          form,
          {},
          {
            "Content-Type": "multipart/form-data",
          },
          idToken,
        );

        resolve(response.data);
      } else {
        var response = await makeRequest(
          method,
          `${BASE_API_URL}${action}`,
          qs.stringify(params),
          null,
          null,
          idToken,
        );
        resolve(response.data);
      }
    } catch (error) {
      reject(error);
    }
  });
}

async function apiAIQueueAction(method, action, params, type, idToken) {
  return new Promise(async (resolve, reject) => {
    try {
      // First make the queue request
      const queueResponse = await makeRequest(
        method,
        `${BASE_API_URL}${action}/queue`,
        qs.stringify(params),
        {},
        {},
        idToken,
      );

      const queueID = queueResponse?.data?.data?.queueID;

      if (!queueID) {
        reject(new Error("No queue ID returned from server"));
        return;
      }

      // Function to check queue status
      const checkQueue = async () => {
        try {
          const queueCheckResponse = await makeRequest(
            "GET",
            `${BASE_API_URL}${action}/queue`,
            null,
            {
              queueID: queueID,
              project_id: params.project_id,
            },
            {},
            idToken,
          );

          const queueData = queueCheckResponse?.data?.data;

          if (queueData?.status === "completed") {
            resolve(queueData);
          } else if (queueData?.status === "pending") {
            // Wait 5 seconds before checking again
            setTimeout(checkQueue, 5000);
          } else {
            reject(new Error("Queue processing failed"));
          }
        } catch (error) {
          reject(error);
        }
      };

      // Start checking queue
      setTimeout(checkQueue, 1000);
    } catch (error) {
      reject(error);
    }
  });
}

export { BASE_API_URL, axios, makeRequest, apiAction, apiAIQueueAction };
